import type { FetchResponse, RequestParams } from 'services/fetch';
import fetch from 'services/fetch';

import type { CountryCodeResponse, GeoIpRecordResponse } from './data-contracts';

/**
 * No description
*
 * @name GeolocationList
 * @summary Returns the data of detected geolocation
 * @request GET:/v1/geolocation
 * @response `200` `GeoIpRecordResponse`
 * @response `500` `{
    errors?: ({
  \** @example "500" *\
    status?: string,
  \** @example "Unexpected error occurred" *\
    title?: string,
  \** @example 7 *\
    code?: number,
  \** @example "An unexpected error occurred in SomeFile.php" *\
    details?: string,

})[],

}` Internal server error message

*/
export const geolocationList = (params: RequestParams = {}): FetchResponse<GeoIpRecordResponse> => {
  return fetch<GeoIpRecordResponse>(`/v1/geolocation`, {
    method: 'GET',
    ...params,
  });
};

/**
 * No description
*
 * @name GeolocationCountryCodeList
 * @summary Returns the country code of detected geolocation
 * @request GET:/v1/geolocation/country-code
 * @response `200` `CountryCodeResponse`
 * @response `500` `void`

*/
export const geolocationCountryCodeList = (params: RequestParams = {}): FetchResponse<CountryCodeResponse> => {
  return fetch<CountryCodeResponse>(`/v1/geolocation/country-code`, {
    method: 'GET',
    ...params,
  });
};
